export default __webpack_public_path__ + "static/cant-change-style-fb1462ee9283f2de18d78edd96d9e309.mp4";